import { promiseDelay } from 'oasis-os-utils';
import { METHODS } from '../types/apiClient';
const isBinary = (data) => data instanceof FormData || data instanceof Blob || data instanceof URLSearchParams;
export default (() => {
    const apiClient = {};
    let { retries, service, logger } = {};
    const setHeaders = (reqIsBin, customHeaders) => {
        const headers = new Headers(customHeaders);
        reqIsBin && headers.delete('content-type');
        return headers;
    };
    const apiFetch = async (url, isNotHost, method, { data, ...opts }, errorRetries) => {
        const reqIsBin = isBinary(data);
        const res = await fetch(url, {
            ...opts,
            method,
            headers: setHeaders(reqIsBin, opts.headers),
            body: reqIsBin ? data : data && JSON.stringify(data),
            credentials: isNotHost ? 'omit' : 'include',
        });
        if (res.status === 401 && errorRetries > 0) {
            return promiseDelay(2000).then(() => apiFetch(url, isNotHost, method, { data, ...opts }, errorRetries - 1));
        }
        return res;
    };
    const handleReponse = (res, textBody) => {
        const contentType = res.headers.get('content-type');
        const contentLength = res.headers.get('content-length');
        const emptyBody = contentLength === '0' || textBody === '';
        if (res.status === 404) {
            throw { name: 'Error', message: 'Something went wrong', code: 404 };
        }
        if (res.status === 409 && res?.headers?.has('x-error-code')) {
            return res;
        }
        if (res.status === 413) {
            throw res;
        }
        if (res.status >= 400) {
            if (emptyBody) {
                throw Error('Something went wrong');
            }
            else {
                if (/application\/.*json/.exec(contentType)) {
                    throw (JSON.parse(textBody));
                }
                throw Error('Something went wrong');
            }
        }
        if (/application\/.*json/.exec(contentType)) {
            return emptyBody ? Promise.resolve({}) : res.json();
        }
        if (/text\/plain/.exec(contentType)) {
            return res.text();
        }
        return res;
    };
    apiClient.setLogger = (loggerIn) => {
        logger = loggerIn;
    };
    apiClient.getLogger = () => {
        return logger;
    };
    Object.values(METHODS).forEach((method) => {
        apiClient[method] = async (path, hostType, { data, ...opts } = {}, isNotHost = false) => {
            try {
                const url = isNotHost ? path : `${service[hostType]}${path}`;
                const res = await apiFetch(url, isNotHost, method, { data, ...opts }, retries);
                const textBody = await res.clone().text();
                return handleReponse(res, textBody);
            }
            catch (error) {
                if (apiClient.getLogger()) {
                    apiClient.getLogger().error({ path, error }, 'Error while calling api');
                }
                throw error;
            }
        };
    });
    apiClient.init = (config) => {
        retries = config.retries ?? 3;
        service = config.service;
    };
    return apiClient;
})();
